

import React, { useState } from "react";
import { Row, Col, Card, message } from "antd";
import { MailOutlined, PhoneOutlined, EnvironmentOutlined, UserOutlined, BankOutlined, MessageOutlined, SendOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";


const Contact = () => {
    // État pour le formulaire de contact
    const EMPTY_CONTACT = { firstName: "", lastName: "", email: "", company: "", requestType: "", message: "" };
    const [contactForm, setContactForm] = useState(EMPTY_CONTACT);
    const [contactErrors, setContactErrors] = useState({});
    const [contactLoading, setContactLoading] = useState(false);
    const [contactSuccess, setContactSuccess] = useState(false);

    const update = (k, v) => setContactForm((p) => ({ ...p, [k]: v }));

    // Validation du formulaire
    const validateContact = () => {
        const e = {};
        if (!contactForm.firstName.trim()) e.firstName = "Champ requis";
        if (!contactForm.lastName.trim()) e.lastName = "Champ requis";
        if (!contactForm.email.trim()) e.email = "Champ requis";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactForm.email)) e.email = "Email invalide";
        if (!contactForm.company.trim()) e.company = "Champ requis";
        if (!contactForm.requestType) e.requestType = "Sélectionnez un type";
        setContactErrors(e);
        return Object.keys(e).length === 0;
    };

    // Soumission du formulaire
    const submitContact = async () => {
        if (!validateContact()) return;
        setContactLoading(true);
        setContactSuccess(false);
        try {
            await courseService.createSalesRequest({
                ...contactForm,
                planId: null,
                planTitle: null,
            });
            setContactSuccess(true);
            setContactForm(EMPTY_CONTACT);
            setContactErrors({});
            message.success("✅ Votre message a été envoyé avec succès !");
        } catch (e) {
            console.error(e);
            message.error("Erreur lors de l'envoi. Réessayez.");
        } finally {
            setContactLoading(false);
        }
    };

    const inputStyle = {
        width: "100%",
        padding: "12px 16px",
        borderRadius: "8px",
        border: "2px solid #e1e8ed",
        fontSize: "14px",
        transition: "all 0.3s ease",
        fontFamily: "inherit"
    };

    const labelStyle = {
        display: "block",
        fontSize: "14px",
        fontWeight: "600",
        marginBottom: "8px",
        color: "#2c3e50"
    };

    const errorStyle = {
        color: "#e74c3c",
        fontSize: "12px",
        marginTop: "6px",
        fontWeight: "500"
    };

    return (
        <div style={{ 
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            minHeight: "100vh",
            padding: "40px 20px"
        }}>
            {/* En-tête */}
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
                <h1 style={{ 
                    color: "white", 
                    fontSize: "42px", 
                    fontWeight: "700",
                    marginBottom: "15px",
                    textShadow: "0 2px 4px rgba(0,0,0,0.3)"
                }}>
                    💬 Nous Contacter
                </h1>
                <p style={{ 
                    color: "rgba(255,255,255,0.9)", 
                    fontSize: "18px",
                    maxWidth: "600px",
                    margin: "0 auto",
                    lineHeight: "1.6"
                }}>
                    Notre équipe est là pour répondre à toutes vos questions et vous accompagner dans vos projets
                </p>
            </div>

            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <Row gutter={[32, 32]} align="top">
                    {/* Informations de Contact */}
                    <Col xs={24} lg={10}>
                        <Card
                            style={{ 
                                borderRadius: "20px", 
                                boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                                border: "none",
                                overflow: "hidden",
                                height: "100%"
                            }}
                        >
                            <div style={{
                                background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                                margin: "-24px -24px 30px -24px",
                                padding: "30px 24px",
                                textAlign: "center"
                            }}>
                                <h2 style={{ 
                                    color: "white", 
                                    fontSize: "24px", 
                                    fontWeight: "600",
                                    margin: "0",
                                    textShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                }}>
                                    📞 Informations de Contact
                                </h2>
                            </div>

                            <div style={{ padding: "0 10px" }}>
                                {/* Email */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    marginBottom: "25px",
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(250, 177, 160, 0.3)"
                                }}>
                                    <MailOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#d63031", 
                                        marginRight: "15px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "#2d3436", fontSize: "16px" }}>Email</div>
                                        <div style={{ color: "#636e72", fontSize: "15px" }}>contact@nomidya.com</div>
                                    </div>
                                </div>

                                {/* Téléphone Canada */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    marginBottom: "25px",
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #a8e6cf 0%, #88d8a3 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(136, 216, 163, 0.3)"
                                }}>
                                    <PhoneOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#00b894", 
                                        marginRight: "15px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "#2d3436", fontSize: "16px" }}>🇨🇦 Canada</div>
                                        <div style={{ color: "#636e72", fontSize: "15px" }}>+1 (418) 809 6316</div>
                                    </div>
                                </div>

                                {/* Téléphone Maroc */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    marginBottom: "25px",
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #fd79a8 0%, #e84393 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(232, 67, 147, 0.3)"
                                }}>
                                    <PhoneOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#e84393", 
                                        marginRight: "15px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "white", fontSize: "16px" }}>🇲🇦 Maroc</div>
                                        <div style={{ color: "rgba(255,255,255,0.9)", fontSize: "15px" }}>+212 661 571 360</div>
                                    </div>
                                </div>

                                {/* Adresse */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "flex-start", 
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(116, 185, 255, 0.3)"
                                }}>
                                    <EnvironmentOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#0984e3", 
                                        marginRight: "15px",
                                        marginTop: "2px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "white", fontSize: "16px" }}>Adresse</div>
                                        <div style={{ color: "rgba(255,255,255,0.9)", fontSize: "15px", lineHeight: "1.5" }}>
                                            753 Rue J-E Cauchon<br/>
                                            G1J 2T1, Canada
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/* Formulaire de Contact */}
                    <Col xs={24} lg={14}>
                        <Card
                            style={{ 
                                borderRadius: "20px", 
                                boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                                border: "none",
                                overflow: "hidden"
                            }}
                        >
                            <div style={{
                                background: "linear-gradient(135deg, #ff7675 0%, #fd79a8 100%)",
                                margin: "-24px -24px 30px -24px",
                                padding: "30px 24px",
                                textAlign: "center"
                            }}>
                                <h2 style={{ 
                                    color: "white", 
                                    fontSize: "24px", 
                                    fontWeight: "600",
                                    margin: "0",
                                    textShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                }}>
                                    ✉️ Envoyez-nous un Message
                                </h2>
                            </div>

                            {contactSuccess && (
                                <div style={{
                                    padding: "20px",
                                    background: "linear-gradient(135deg, #00b894 0%, #00cec9 100%)",
                                    borderRadius: "12px",
                                    color: "white",
                                    textAlign: "center",
                                    marginBottom: "20px",
                                    fontWeight: "600",
                                    fontSize: "16px"
                                }}>
                                    ✅ Merci ! Votre message a été envoyé avec succès !
                                </div>
                            )}

                            <Row gutter={[16, 0]}>
                                <Col xs={24} sm={12}>
                                    <div style={{ marginBottom: "20px" }}>
                                        <label style={labelStyle}>
                                            <UserOutlined style={{ marginRight: "5px", color: "#667eea" }} />
                                            Prénom <span style={{ color: "#e74c3c" }}>*</span>
                                        </label>
                                        <input
                                            style={{
                                                ...inputStyle,
                                                borderColor: contactErrors.firstName ? "#e74c3c" : "#e1e8ed"
                                            }}
                                            value={contactForm.firstName}
                                            onChange={(e) => update("firstName", e.target.value)}
                                            placeholder="Votre prénom"
                                            onFocus={(e) => e.target.style.borderColor = "#667eea"}
                                            onBlur={(e) => e.target.style.borderColor = contactErrors.firstName ? "#e74c3c" : "#e1e8ed"}
                                        />
                                        {contactErrors.firstName && <div style={errorStyle}>{contactErrors.firstName}</div>}
                                    </div>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <div style={{ marginBottom: "20px" }}>
                                        <label style={labelStyle}>
                                            <UserOutlined style={{ marginRight: "5px", color: "#667eea" }} />
                                            Nom de famille <span style={{ color: "#e74c3c" }}>*</span>
                                        </label>
                                        <input
                                            style={{
                                                ...inputStyle,
                                                borderColor: contactErrors.lastName ? "#e74c3c" : "#e1e8ed"
                                            }}
                                            value={contactForm.lastName}
                                            onChange={(e) => update("lastName", e.target.value)}
                                            placeholder="Votre nom"
                                            onFocus={(e) => e.target.style.borderColor = "#667eea"}
                                            onBlur={(e) => e.target.style.borderColor = contactErrors.lastName ? "#e74c3c" : "#e1e8ed"}
                                        />
                                        {contactErrors.lastName && <div style={errorStyle}>{contactErrors.lastName}</div>}
                                    </div>
                                </Col>
                            </Row>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    <MailOutlined style={{ marginRight: "5px", color: "#667eea" }} />
                                    Courriel professionnel <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    style={{
                                        ...inputStyle,
                                        borderColor: contactErrors.email ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={contactForm.email}
                                    onChange={(e) => update("email", e.target.value)}
                                    placeholder="prenom.nom@entreprise.com"
                                    onFocus={(e) => e.target.style.borderColor = "#667eea"}
                                    onBlur={(e) => e.target.style.borderColor = contactErrors.email ? "#e74c3c" : "#e1e8ed"}
                                />
                                {contactErrors.email && <div style={errorStyle}>{contactErrors.email}</div>}
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    <BankOutlined style={{ marginRight: "5px", color: "#667eea" }} />
                                    Nom de l'entreprise <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <input
                                    style={{
                                        ...inputStyle,
                                        borderColor: contactErrors.company ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={contactForm.company}
                                    onChange={(e) => update("company", e.target.value)}
                                    placeholder="Ex. NOMIDYA Technologies"
                                    onFocus={(e) => e.target.style.borderColor = "#667eea"}
                                    onBlur={(e) => e.target.style.borderColor = contactErrors.company ? "#e74c3c" : "#e1e8ed"}
                                />
                                {contactErrors.company && <div style={errorStyle}>{contactErrors.company}</div>}
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    📋 Type de demande <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <select
                                    style={{
                                        ...inputStyle,
                                        borderColor: contactErrors.requestType ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={contactForm.requestType}
                                    onChange={(e) => update("requestType", e.target.value)}
                                    onFocus={(e) => e.target.style.borderColor = "#667eea"}
                                    onBlur={(e) => e.target.style.borderColor = contactErrors.requestType ? "#e74c3c" : "#e1e8ed"}
                                >
                                    <option value="">Veuillez sélectionner</option>
                                    <option value="info">💡 Demande d'informations</option>
                                    <option value="devis">💰 Demande de devis</option>
                                    <option value="demo">🎯 Demander une démo</option>
                                    <option value="autre">❓ Autre</option>
                                </select>
                                {contactErrors.requestType && <div style={errorStyle}>{contactErrors.requestType}</div>}
                            </div>

                            <div style={{ marginBottom: "30px" }}>
                                <label style={labelStyle}>
                                    <MessageOutlined style={{ marginRight: "5px", color: "#667eea" }} />
                                    Message (optionnel)
                                </label>
                                <textarea
                                    style={{
                                        ...inputStyle,
                                        minHeight: "120px",
                                        resize: "vertical"
                                    }}
                                    value={contactForm.message}
                                    onChange={(e) => update("message", e.target.value)}
                                    placeholder="Décrivez brièvement votre besoin, vos attentes ou toute information complémentaire..."
                                    onFocus={(e) => e.target.style.borderColor = "#667eea"}
                                    onBlur={(e) => e.target.style.borderColor = "#e1e8ed"}
                                />
                            </div>

                            <div style={{ textAlign: "center" }}>
                                <button
                                    onClick={submitContact}
                                    disabled={contactLoading}
                                    style={{
                                        background: contactLoading ? "#95a5a6" : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "12px",
                                        padding: "15px 40px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        cursor: contactLoading ? "not-allowed" : "pointer",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 8px 25px rgba(102, 126, 234, 0.4)",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px"
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!contactLoading) {
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                            e.currentTarget.style.boxShadow = "0 12px 35px rgba(102, 126, 234, 0.6)";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!contactLoading) {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 8px 25px rgba(102, 126, 234, 0.4)";
                                        }
                                    }}
                                >
                                    {contactLoading ? (
                                        <>
                                            <div style={{
                                                width: "16px",
                                                height: "16px",
                                                border: "2px solid rgba(255,255,255,0.3)",
                                                borderTop: "2px solid white",
                                                borderRadius: "50%",
                                                animation: "spin 1s linear infinite"
                                            }} />
                                            Envoi en cours...
                                        </>
                                    ) : (
                                        <>
                                            <SendOutlined />
                                            Envoyer le Message
                                        </>
                                    )}
                                </button>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>

            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Contact;